import { create } from "zustand";
import type { UserState, UserProfile, UserTokens } from "./types";

export const useUserStore = create<UserState>((set) => ({
  user: null,

  tokens: {
    cognitoIdToken: "",
    backendToken: "",
  },

  setUser: (user: UserProfile) => set({ user }),

  setTokens: (tokens: Partial<UserTokens>) =>
    set((state) => ({
      tokens: {
        ...state.tokens,
        ...tokens,
      },
    })),

  resetUser: () =>
    set({
      user: null,
      tokens: {
        cognitoIdToken: "",
        backendToken: "",
      },
    }),
}));
